module.exports = __webpack_public_path__ + "img/load-3-3.70f95863.png";